export const billingInformationFileDefaultValue = {
    email: '',
    first_name: '',
    last_name: '',
};
export const paymentFormDefaultValues = {
    is_draft: false,
    payment: {
        billing_information: [],
        options: null,
    },
};
